/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал хранения пресетов устройств
 */

/**
 * Сервис пресетов
 */
export class PresetServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения пресетов.
   * Поддерживает создание и обновление.
   * При обновлении пресета посылается задача PresetInstallTask в очередь key.preset.install.
   * Данное сообщение должно отправляться только если изменению подверглось одно из следующих полей:
   * - Sip;
   * - Ntp;
   * - Syslog;
   * - Room;
   * - VideoConfig;
   * - Dtmf.
   * Метод доступен для: admin, service
   */
  PostPreset = (req: PostPresetRequestDto, init?: RequestInit): Promise<PostPresetResponseDto> => {
    return fm.request<PostPresetRequestDto, PostPresetResponseDto>(`${this.host}/preset/api/v1/preset`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения пресета по идентификатору.
   * Метод доступен для: admin, service, bti, ltp_first, owner, employee
   */
  GetPreset = (req: GetPresetRequestDto, init?: RequestInit): Promise<GetPresetResponseDto> => {
    return fm.request<GetPresetRequestDto, GetPresetResponseDto>(`${this.host}/preset/api/v1/preset/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения дефолтного пресета.
   * Метод доступен для: admin, service, bti, ltp_first, owner, employee
   */
  GetPresetDefault = (req?: GetPresetDefaultRequestDto, init?: RequestInit): Promise<GetPresetDefaultResponseDto> => {
    return fm.request<GetPresetDefaultRequestDto, GetPresetDefaultResponseDto>(`${this.host}/preset/api/v1/preset/default${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения пресетов.
   * Метод доступен для: admin, service, bti, ltp_first, owner, employee
   */
  GetPresetList = (req?: GetPresetListRequestDto, init?: RequestInit): Promise<GetPresetListResponseDto[]> => {
    return fm.list<GetPresetListRequestDto, GetPresetListResponseDto>(`${this.host}/preset/api/v1/preset/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества пресетов.
   * Метод доступен для: admin, service, bti, ltp_first, owner, employee
   */
  GetPresetCount = (req?: GetPresetCountRequestDto, init?: RequestInit): Promise<GetPresetCountResponseDto> => {
    return fm.request<GetPresetCountRequestDto, GetPresetCountResponseDto>(`${this.host}/preset/api/v1/preset/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления пресета.
   * Нельзя удалить пресет, если он используется на устройстве.
   * Нельзя удалить дефолтный пресет.
   * Метод доступен для: admin, service
   */
  DeletePreset = (req: DeletePresetRequestDto, init?: RequestInit): Promise<DeletePresetResponseDto> => {
    return fm.request<DeletePresetRequestDto, DeletePresetResponseDto>(`${this.host}/preset/api/v1/preset/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип конфигурации
 */
export enum PresetFaceRecognitionConfigurationType {
  /**
   * Значение не указано
   */
  CONFIGURATION_TYPE_UNKNOWN = "CONFIGURATION_TYPE_UNKNOWN",
  /**
   * По умолчанию
   */
  DEFAULT = "DEFAULT",
}
/**
 * Тип конфигурации
 */
export type PresetFaceRecognitionConfigurationTypeResponseEnum = keyof typeof PresetFaceRecognitionConfigurationType
/**
 * Тип конфигурации
 */
export type PresetFaceRecognitionConfigurationTypeRequestEnum = Exclude<PresetFaceRecognitionConfigurationTypeResponseEnum, "CONFIGURATION_TYPE_UNKNOWN">;

/**
 * Справочник статусов.
 */
export enum PresetStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Активный
   */
  ACTIVE = "ACTIVE",
  /**
   * Архивный
   */
  ARCHIVE = "ARCHIVE",
}
/**
 * Справочник статусов.
 */
export type PresetStatusTypeResponseEnum = keyof typeof PresetStatusType
/**
 * Справочник статусов.
 */
export type PresetStatusTypeRequestEnum = Exclude<PresetStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Тип протокола.
 */
export enum PresetSyslogProtocolType {
  /**
   * Значение не указано
   */
  PROTOCOL_TYPE_UNKNOWN = "PROTOCOL_TYPE_UNKNOWN",
  /**
   * Протокол UDP
   */
  UDP = "UDP",
  /**
   * Протокол TCP
   */
  TCP = "TCP",
}
/**
 * Тип протокола.
 */
export type PresetSyslogProtocolTypeResponseEnum = keyof typeof PresetSyslogProtocolType
/**
 * Тип протокола.
 */
export type PresetSyslogProtocolTypeRequestEnum = Exclude<PresetSyslogProtocolTypeResponseEnum, "PROTOCOL_TYPE_UNKNOWN">;

/**
 * Справочник качеств.
 */
export enum PresetVideoConfigQualityType {
  /**
   * Значение не указано
   */
  QUALITY_TYPE_UNKNOWN = "QUALITY_TYPE_UNKNOWN",
  /**
   * Высокое качество
   */
  HIGH = "HIGH",
  /**
   * Среднее качество
   */
  MEDIUM = "MEDIUM",
}
/**
 * Справочник качеств.
 */
export type PresetVideoConfigQualityTypeResponseEnum = keyof typeof PresetVideoConfigQualityType
/**
 * Справочник качеств.
 */
export type PresetVideoConfigQualityTypeRequestEnum = Exclude<PresetVideoConfigQualityTypeResponseEnum, "QUALITY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum PresetPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type PresetPagingDirectionTypeResponseEnum = keyof typeof PresetPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type PresetPagingDirectionTypeRequestEnum = Exclude<PresetPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum PresetPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По времени создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По времени изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type PresetPagingOrderByTypeResponseEnum = keyof typeof PresetPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type PresetPagingOrderByTypeRequestEnum = Exclude<PresetPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления пресета
 */
export type DeletePresetRequestDto = {
  /**
   * Идентификатор пресета
   */
  id: number
}
/**
 * Ответ на запрос удаления пресета
 */
export type DeletePresetResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка при удалении
   */
  readonly error: DeletePresetResponseErrorDto
}>
/**
 * Ошибка при удалении
 */
export type DeletePresetResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Запрещено для дефолтного пресета
   */
  readonly notAllowedForDefault: DeletePresetResponseErrorNotAllowedForDefaultRequestDto
}>
/**
 * Ошибка при удалении
 */
export type DeletePresetResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Запрещено для дефолтного пресета
   */
  readonly notAllowedForDefault: DeletePresetResponseErrorNotAllowedForDefaultDto
}>
/**
 * Недоступно для дефолтного пресета
 */
export type DeletePresetResponseErrorNotAllowedForDefaultRequestDto = {
}
/**
 * Недоступно для дефолтного пресета
 */
export type DeletePresetResponseErrorNotAllowedForDefaultDto = {
}
/**
 * Запрос получения количества пресетов
 */
export type GetPresetCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: PresetFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества пресетов
 */
export type GetPresetCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего пресетов
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetPresetCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества пресетов
 */
export type GetPresetCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества пресетов
 */
export type GetPresetCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения дефолтного пресета
 */
export type GetPresetDefaultRequestDto = {
}
/**
 * Ответ на запрос получения дефолтного пресета
 */
export type GetPresetDefaultResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пресет
   */
  readonly data: PresetResponseDto
}>
/**
 * Запрос на получение списка пресетов
 */
export type GetPresetListRequestDto = {
  /**
   * Фильтр
   */
  filter?: PresetFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: PresetPagingRequestDto
}>
/**
 * Ответ на получение списка пресетов
 */
export type GetPresetListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пресет
   */
  readonly data: PresetResponseDto
  /**
   * Ошибка
   */
  readonly error: GetPresetListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка пресетов
 */
export type GetPresetListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка пресетов
 */
export type GetPresetListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения пресета
 */
export type GetPresetRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос получения пресета
 */
export type GetPresetResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пресет
   */
  readonly data: PresetResponseDto
}>
/**
 * Запрос на создание/изменение пресета
 */
export type PostPresetRequestDto = {
  /**
   * Пресет
   */
  data: PresetRequestDto
}
/**
 * Ответ на запрос на создание/изменение пресета
 */
export type PostPresetResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пресет
   */
  readonly data: PresetResponseDto
  /**
   * Ошибка
   */
  readonly error: PostPresetResponseErrorDto
}>
/**
 * Ошибка запроса сохранения пресета
 */
export type PostPresetResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: PresetSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения пресета
 */
export type PostPresetResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: PresetSavingErrorResponseDto
}>
/**
 * Пресет.
 * Пресет с id=1 является дефолтным пресетом.
 * # Описание модели
 */
export type PresetRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id?: number
  /**
   * Наименование.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Идентификатор МРФ.
   * # Диапазон: 0..10
   */
  mrfIds: number[]
  /**
   * Идентификатор РФ.
   * # Диапазон: 0..100
   */
  rfIds: number[]
  /**
   * Описание.
   * # Диапазон: 3..1024
   */
  description?: string | null
  /**
   * Статус
   */
  statusType: PresetStatusTypeRequestEnum
  /**
   * Параметр SIP
   */
  sip: PresetSipRequestDto
  /**
   * Параметр NTP
   */
  ntp: PresetNtpRequestDto
  /**
   * Параметр Syslog
   */
  syslog: PresetSyslogRequestDto
  /**
   * Помещения.
   * # Диапазон: 0..10000
   */
  rooms: PresetRoomRequestDto[]
  /**
   * Параметры конфигурации видео
   */
  videoConfig: PresetVideoConfigRequestDto
  /**
   * Параметр DTMF.
   * # Диапазон: 0..64
   */
  dtmf: PresetDtmfRequestDto[]
  /**
   * Распознование лиц
   */
  faceRecognition?: PresetFaceRecognitionRequestDto | null
}
/**
 * Пресет.
 * Пресет с id=1 является дефолтным пресетом.
 * # Описание модели
 */
export type PresetResponseDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * Наименование.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Идентификатор МРФ.
   * # Диапазон: 0..10
   */
  mrfIds: number[]
  /**
   * Идентификатор РФ.
   * # Диапазон: 0..100
   */
  rfIds: number[]
  /**
   * Описание.
   * # Диапазон: 3..1024
   */
  description: string | null
  /**
   * Дата и время создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
  /**
   * Статус
   */
  statusType: PresetStatusTypeResponseEnum
  /**
   * Параметр SIP
   */
  sip: PresetSipResponseDto
  /**
   * Параметр NTP
   */
  ntp: PresetNtpResponseDto
  /**
   * Параметр Syslog
   */
  syslog: PresetSyslogResponseDto
  /**
   * Помещения.
   * # Диапазон: 0..10000
   */
  rooms: PresetRoomResponseDto[]
  /**
   * Параметры конфигурации видео
   */
  videoConfig: PresetVideoConfigResponseDto
  /**
   * Параметр DTMF.
   * # Диапазон: 0..64
   */
  dtmf: PresetDtmfResponseDto[]
  /**
   * Распознование лиц
   */
  faceRecognition: PresetFaceRecognitionResponseDto | null
}
/**
 * Параметр DTMF
 */
export type PresetDtmfRequestDto = {
  /**
   * Код.
   * # Диапазон: 1..1
   */
  code: string
  /**
   * Индекс реле.
   * # Диапазон: 0..64
   */
  relayIndex?: number
}
/**
 * Параметр DTMF
 */
export type PresetDtmfResponseDto = {
  /**
   * Код.
   * # Диапазон: 1..1
   */
  code: string
  /**
   * Индекс реле.
   * # Диапазон: 0..64
   */
  relayIndex: number
}
/**
 * Распознование лиц
 */
export type PresetFaceRecognitionRequestDto = {
  /**
   * Адрес
   */
  host: string
  /**
   * Альтернативный адрес
   */
  altHost?: string
  /**
   * Путь запроса к серверу
   */
  endpoint: string
  /**
   * Токен
   */
  authToken: string
  /**
   * Тип конфигурации
   */
  configurationType: PresetFaceRecognitionConfigurationTypeRequestEnum
  /**
   * Идентификатор источника в identix
   */
  originId: string
  /**
   * Идентификаторы групп профилей в identix
   */
  groupIds?: number[]
}
/**
 * Распознование лиц
 */
export type PresetFaceRecognitionResponseDto = {
  /**
   * Адрес
   */
  host: string
  /**
   * Альтернативный адрес
   */
  altHost: string
  /**
   * Путь запроса к серверу
   */
  endpoint: string
  /**
   * Токен
   */
  authToken: string
  /**
   * Тип конфигурации
   */
  configurationType: PresetFaceRecognitionConfigurationTypeResponseEnum
  /**
   * Идентификатор источника в identix
   */
  originId: string
  /**
   * Идентификаторы групп профилей в identix
   */
  groupIds: number[]
}
/**
 * Параметр NTP
 */
export type PresetNtpRequestDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
}
/**
 * Параметр NTP
 */
export type PresetNtpResponseDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
}
/**
 * Помещение
 */
export type PresetRoomRequestDto = {
  /**
   * Номер телефона.
   * # Диапазон: 5..14
   */
  phone: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  num: number
}
/**
 * Помещение
 */
export type PresetRoomResponseDto = {
  /**
   * Номер телефона.
   * # Диапазон: 5..14
   */
  phone: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  num: number
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type PresetSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: PresetSavingErrorConflictRequestDto
  /**
   * Запрещено для дефолтного пресета
   */
  readonly notAllowedForDefault: PresetSavingErrorNotAllowedForDefaultRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type PresetSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: PresetSavingErrorConflictResponseDto
  /**
   * Запрещено для дефолтного пресета
   */
  readonly notAllowedForDefault: PresetSavingErrorNotAllowedForDefaultResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type PresetSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type PresetSavingErrorConflictResponseDto = {
}
/**
 * Недоступно для дефолтного пресета.
 * Причины:
 * - Смена статуса на Архивный
 */
export type PresetSavingErrorNotAllowedForDefaultRequestDto = {
}
/**
 * Недоступно для дефолтного пресета.
 * Причины:
 * - Смена статуса на Архивный
 */
export type PresetSavingErrorNotAllowedForDefaultResponseDto = {
}
/**
 * Параметр SIP
 */
export type PresetSipRequestDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
  /**
   * Хост reg.
   * # Диапазон: 5..256
   */
  regHost: string
  /**
   * Порт reg.
   * # Диапазон: 1..65536
   */
  regPort: number
  /**
   * Хост proxy.
   * # Диапазон: 5..256
   */
  proxyHost: string
  /**
   * Порт proxy.
   * # Диапазон: 1..65536
   */
  proxyPort: number
}
/**
 * Параметр SIP
 */
export type PresetSipResponseDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
  /**
   * Хост reg.
   * # Диапазон: 5..256
   */
  regHost: string
  /**
   * Порт reg.
   * # Диапазон: 1..65536
   */
  regPort: number
  /**
   * Хост proxy.
   * # Диапазон: 5..256
   */
  proxyHost: string
  /**
   * Порт proxy.
   * # Диапазон: 1..65536
   */
  proxyPort: number
}
/**
 * Параметр Syslog
 */
export type PresetSyslogRequestDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
  /**
   * Протокол
   */
  protocolType: PresetSyslogProtocolTypeRequestEnum
}
/**
 * Параметр Syslog
 */
export type PresetSyslogResponseDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
  /**
   * Протокол
   */
  protocolType: PresetSyslogProtocolTypeResponseEnum
}
/**
 * Параметры конфигурации видео
 */
export type PresetVideoConfigRequestDto = {
  /**
   * Тип пресета
   */
  qualityType: PresetVideoConfigQualityTypeRequestEnum
  /**
   * Пользователь
   */
  rtspUser: PresetVideoConfigRtspUserRequestDto
}
/**
 * Параметры конфигурации видео
 */
export type PresetVideoConfigResponseDto = {
  /**
   * Тип пресета
   */
  qualityType: PresetVideoConfigQualityTypeResponseEnum
  /**
   * Пользователь
   */
  rtspUser: PresetVideoConfigRtspUserResponseDto
}
/**
 * Пользователь
 */
export type PresetVideoConfigRtspUserRequestDto = {
  /**
   * Имя пользователя.
   * # Диапазон: 3..256
   */
  username: string
  /**
   * Пароль.
   * # Диапазон: 3..256
   */
  password: string
}
/**
 * Пользователь
 */
export type PresetVideoConfigRtspUserResponseDto = {
  /**
   * Имя пользователя.
   * # Диапазон: 3..256
   */
  username: string
  /**
   * Пароль.
   * # Диапазон: 3..256
   */
  password: string
}
/**
 * Фильтр по пресетам
 */
export type PresetFilterRequestDto = {
  /**
   * По идентификаторам МРФ
   */
  mrfIds?: number[]
  /**
   * По идентификаторам РФ
   */
  rfIds?: number[]
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text?: string | null
  /**
   * Поиск по наименованию.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  title?: string | null
  /**
   * По статусам
   */
  statusTypes?: PresetStatusTypeResponseEnum[]
}
/**
 * Фильтр по пресетам
 */
export type PresetFilterResponseDto = {
  /**
   * По идентификаторам МРФ
   */
  mrfIds: number[]
  /**
   * По идентификаторам РФ
   */
  rfIds: number[]
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - Описание
   */
  text: string | null
  /**
   * Поиск по наименованию.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  title: string | null
  /**
   * По статусам
   */
  statusTypes: PresetStatusTypeResponseEnum[]
}
/**
 * Постраничный вывод
 */
export type PresetPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: PresetPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: PresetPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type PresetPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: PresetPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: PresetPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления пресета
   */
  "DeletePresetRequest": {
    "kind": "class",
    "text": "Запрос удаления пресета",
    "fields": {
      /**
       * Идентификатор пресета
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор пресета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления пресета
   */
  "DeletePresetResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления пресета",
    "fields": {
      /**
       * Ошибка при удалении
       */
      "error": {
        "type": "DeletePresetResponse.Error",
        "text": "Ошибка при удалении",
      },
    },
  },
  /**
   * Ошибка при удалении
   */
  "DeletePresetResponse.Error": {
    "kind": "class",
    "text": "Ошибка при удалении",
    "fields": {
      /**
       * Запрещено для дефолтного пресета
       */
      "notAllowedForDefault": {
        "type": "DeletePresetResponse.Error.NotAllowedForDefault",
        "text": "Запрещено для дефолтного пресета",
      },
    },
  },
  /**
   * Недоступно для дефолтного пресета
   */
  "DeletePresetResponse.Error.NotAllowedForDefault": {
    "kind": "class",
    "text": "Недоступно для дефолтного пресета",
  },
  /**
   * Запрос получения количества пресетов
   */
  "GetPresetCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества пресетов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PresetFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества пресетов
   */
  "GetPresetCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества пресетов",
    "fields": {
      /**
       * Всего пресетов
       */
      "data": {
        "type": "int32",
        "text": "Всего пресетов",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPresetCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества пресетов
   */
  "GetPresetCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества пресетов",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения дефолтного пресета
   */
  "GetPresetDefaultRequest": {
    "kind": "class",
    "text": "Запрос получения дефолтного пресета",
  },
  /**
   * Ответ на запрос получения дефолтного пресета
   */
  "GetPresetDefaultResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения дефолтного пресета",
    "fields": {
      /**
       * Пресет
       */
      "data": {
        "type": "Preset",
        "text": "Пресет",
      },
    },
  },
  /**
   * Запрос на получение списка пресетов
   */
  "GetPresetListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка пресетов",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "PresetFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "PresetPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на получение списка пресетов
   */
  "GetPresetListResponse": {
    "kind": "class",
    "text": "Ответ на получение списка пресетов",
    "fields": {
      /**
       * Пресет
       */
      "data": {
        "type": "Preset",
        "text": "Пресет",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetPresetListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка пресетов
   */
  "GetPresetListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка пресетов",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения пресета
   */
  "GetPresetRequest": {
    "kind": "class",
    "text": "Запрос получения пресета",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения пресета
   */
  "GetPresetResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения пресета",
    "fields": {
      /**
       * Пресет
       */
      "data": {
        "type": "Preset",
        "text": "Пресет",
      },
    },
  },
  /**
   * Запрос на создание/изменение пресета
   */
  "PostPresetRequest": {
    "kind": "class",
    "text": "Запрос на создание/изменение пресета",
    "fields": {
      /**
       * Пресет
       */
      "data": {
        "type": "Preset",
        "text": "Пресет",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создание/изменение пресета
   */
  "PostPresetResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создание/изменение пресета",
    "fields": {
      /**
       * Пресет
       */
      "data": {
        "type": "Preset",
        "text": "Пресет",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostPresetResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения пресета
   */
  "PostPresetResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения пресета",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Preset.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Пресет.
   * Пресет с id=1 является дефолтным пресетом.
   * # Описание модели
   */
  "Preset": {
    "kind": "class",
    "text": "Пресет.\nПресет с id=1 является дефолтным пресетом.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Наименование.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Наименование.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Идентификатор МРФ.
       * # Диапазон: 0..10
       */
      "mrfIds": {
        "type": "int32",
        "text": "Идентификатор МРФ.\n# Диапазон: 0..10",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
      /**
       * Идентификатор РФ.
       * # Диапазон: 0..100
       */
      "rfIds": {
        "type": "int32",
        "text": "Идентификатор РФ.\n# Диапазон: 0..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Описание.
       * # Диапазон: 3..1024
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание.\n# Диапазон: 3..1024",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 1024,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1024"
          },
        }
      },
      /**
       * Дата и время создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Статус
       */
      "statusType": {
        "type": "Preset.StatusType",
        "text": "Статус",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр SIP
       */
      "sip": {
        "type": "Preset.Sip",
        "text": "Параметр SIP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр NTP
       */
      "ntp": {
        "type": "Preset.Ntp",
        "text": "Параметр NTP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр Syslog
       */
      "syslog": {
        "type": "Preset.Syslog",
        "text": "Параметр Syslog",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Помещения.
       * # Диапазон: 0..10000
       */
      "rooms": {
        "type": "Preset.Room",
        "text": "Помещения.\n# Диапазон: 0..10000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10000"
          },
        }
      },
      /**
       * Параметры конфигурации видео
       */
      "videoConfig": {
        "type": "Preset.VideoConfig",
        "text": "Параметры конфигурации видео",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр DTMF.
       * # Диапазон: 0..64
       */
      "dtmf": {
        "type": "Preset.Dtmf",
        "text": "Параметр DTMF.\n# Диапазон: 0..64",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Распознование лиц
       */
      "faceRecognition": {
        "type": "Preset.FaceRecognition",
        "text": "Распознование лиц",
      },
    },
  },
  /**
   * Параметр DTMF
   */
  "Preset.Dtmf": {
    "kind": "class",
    "text": "Параметр DTMF",
    "fields": {
      /**
       * Код.
       * # Диапазон: 1..1
       */
      "code": {
        "type": "string",
        "text": "Код.\n# Диапазон: 1..1",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1"
          },
        }
      },
      /**
       * Индекс реле.
       * # Диапазон: 0..64
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\n# Диапазон: 0..64",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
    },
  },
  /**
   * Распознование лиц
   */
  "Preset.FaceRecognition": {
    "kind": "class",
    "text": "Распознование лиц",
    "fields": {
      /**
       * Адрес
       */
      "host": {
        "type": "string",
        "text": "Адрес",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Альтернативный адрес
       */
      "altHost": {
        "type": "string",
        "text": "Альтернативный адрес",
      },
      /**
       * Путь запроса к серверу
       */
      "endpoint": {
        "type": "string",
        "text": "Путь запроса к серверу",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Токен
       */
      "authToken": {
        "type": "string",
        "text": "Токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип конфигурации
       */
      "configurationType": {
        "type": "Preset.FaceRecognition.ConfigurationType",
        "text": "Тип конфигурации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор источника в identix
       */
      "originId": {
        "type": "string",
        "text": "Идентификатор источника в identix",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификаторы групп профилей в identix
       */
      "groupIds": {
        "type": "int32",
        "text": "Идентификаторы групп профилей в identix",
      },
    },
  },
  /**
   * Параметр NTP
   */
  "Preset.Ntp": {
    "kind": "class",
    "text": "Параметр NTP",
    "fields": {
      /**
       * Хост.
       * # Диапазон: 5..256
       */
      "host": {
        "type": "string",
        "text": "Хост.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт.
       * # Диапазон: 1..65536
       */
      "port": {
        "type": "int32",
        "text": "Порт.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
    },
  },
  /**
   * Помещение
   */
  "Preset.Room": {
    "kind": "class",
    "text": "Помещение",
    "fields": {
      /**
       * Номер телефона.
       * # Диапазон: 5..14
       */
      "phone": {
        "type": "string",
        "text": "Номер телефона.\n# Диапазон: 5..14",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 14,
            "message": "Значение не входит в допустимый диапазон. Максимум: 14"
          },
        }
      },
      /**
       * Номер помещения.
       * # Диапазон: 1..10000
       */
      "num": {
        "type": "int32",
        "text": "Номер помещения.\n# Диапазон: 1..10000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10000"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "Preset.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "Preset.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Запрещено для дефолтного пресета
       */
      "notAllowedForDefault": {
        "type": "Preset.SavingError.NotAllowedForDefault",
        "text": "Запрещено для дефолтного пресета",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "Preset.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Недоступно для дефолтного пресета.
   * Причины:
   * - Смена статуса на Архивный
   */
  "Preset.SavingError.NotAllowedForDefault": {
    "kind": "class",
    "text": "Недоступно для дефолтного пресета.\nПричины:\n- Смена статуса на Архивный",
  },
  /**
   * Параметр SIP
   */
  "Preset.Sip": {
    "kind": "class",
    "text": "Параметр SIP",
    "fields": {
      /**
       * Хост.
       * # Диапазон: 5..256
       */
      "host": {
        "type": "string",
        "text": "Хост.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт.
       * # Диапазон: 1..65536
       */
      "port": {
        "type": "int32",
        "text": "Порт.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Хост reg.
       * # Диапазон: 5..256
       */
      "regHost": {
        "type": "string",
        "text": "Хост reg.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт reg.
       * # Диапазон: 1..65536
       */
      "regPort": {
        "type": "int32",
        "text": "Порт reg.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Хост proxy.
       * # Диапазон: 5..256
       */
      "proxyHost": {
        "type": "string",
        "text": "Хост proxy.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт proxy.
       * # Диапазон: 1..65536
       */
      "proxyPort": {
        "type": "int32",
        "text": "Порт proxy.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
    },
  },
  /**
   * Параметр Syslog
   */
  "Preset.Syslog": {
    "kind": "class",
    "text": "Параметр Syslog",
    "fields": {
      /**
       * Хост.
       * # Диапазон: 5..256
       */
      "host": {
        "type": "string",
        "text": "Хост.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт.
       * # Диапазон: 1..65536
       */
      "port": {
        "type": "int32",
        "text": "Порт.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Протокол
       */
      "protocolType": {
        "type": "Preset.Syslog.ProtocolType",
        "text": "Протокол",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Параметры конфигурации видео
   */
  "Preset.VideoConfig": {
    "kind": "class",
    "text": "Параметры конфигурации видео",
    "fields": {
      /**
       * Тип пресета
       */
      "qualityType": {
        "type": "Preset.VideoConfig.QualityType",
        "text": "Тип пресета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пользователь
       */
      "rtspUser": {
        "type": "Preset.VideoConfig.RtspUser",
        "text": "Пользователь",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Пользователь
   */
  "Preset.VideoConfig.RtspUser": {
    "kind": "class",
    "text": "Пользователь",
    "fields": {
      /**
       * Имя пользователя.
       * # Диапазон: 3..256
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Пароль.
       * # Диапазон: 3..256
       */
      "password": {
        "type": "string",
        "text": "Пароль.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
    },
  },
  /**
   * Фильтр по пресетам
   */
  "PresetFilter": {
    "kind": "class",
    "text": "Фильтр по пресетам",
    "fields": {
      /**
       * По идентификаторам МРФ
       */
      "mrfIds": {
        "type": "int32",
        "text": "По идентификаторам МРФ",
      },
      /**
       * По идентификаторам РФ
       */
      "rfIds": {
        "type": "int32",
        "text": "По идентификаторам РФ",
      },
      /**
       * Поиск по тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование;
       * # - Описание
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "Поиск по тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование;\n# - Описание",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Поиск по наименованию.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование
       */
      "title": {
        "type": "google.protobuf.StringValue",
        "text": "Поиск по наименованию.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По статусам
       */
      "statusTypes": {
        "type": "Preset.StatusType",
        "text": "По статусам",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "PresetPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "PresetPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "PresetPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Тип конфигурации
   */
  "Preset.FaceRecognition.ConfigurationType": {
    "kind": "enum",
    "text": "Тип конфигурации",
    "values": {
      /**
       * Значение не указано
       */
      "CONFIGURATION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По умолчанию
       */
      "DEFAULT": {
        "i": 1,
        "text": "По умолчанию",
      },
    },
  },
  /**
   * Справочник статусов.
   */
  "Preset.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Активный
       */
      "ACTIVE": {
        "i": 1,
        "text": "Активный",
      },
      /**
       * Архивный
       */
      "ARCHIVE": {
        "i": 2,
        "text": "Архивный",
      },
    },
  },
  /**
   * Тип протокола.
   */
  "Preset.Syslog.ProtocolType": {
    "kind": "enum",
    "text": "Тип протокола.",
    "values": {
      /**
       * Значение не указано
       */
      "PROTOCOL_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Протокол UDP
       */
      "UDP": {
        "i": 1,
        "text": "Протокол UDP",
      },
      /**
       * Протокол TCP
       */
      "TCP": {
        "i": 2,
        "text": "Протокол TCP",
      },
    },
  },
  /**
   * Справочник качеств.
   */
  "Preset.VideoConfig.QualityType": {
    "kind": "enum",
    "text": "Справочник качеств.",
    "values": {
      /**
       * Значение не указано
       */
      "QUALITY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Высокое качество
       */
      "HIGH": {
        "i": 1,
        "text": "Высокое качество",
      },
      /**
       * Среднее качество
       */
      "MEDIUM": {
        "i": 2,
        "text": "Среднее качество",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "PresetPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "PresetPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По времени создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "По времени создания",
      },
      /**
       * По времени изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "По времени изменения",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 4,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}